class cartSampleSelector extends HTMLElement{
  connectedCallback() {
    this.querySelectorAll('.js-tab-btn').forEach(button => {
      button.addEventListener('click',this.handleTabClick.bind(this));
    });
  }
  handleTabClick(event){
    let button = event.currentTarget;
    let tabContents = this.querySelectorAll('[id^="tab_content"]');
    tabContents.forEach(content => content.setAttribute('hidden',true));
    this.querySelectorAll('.js-tab-btn').forEach(button => button.ariaSelected = false);
    let targetElement = document.getElementById(button.getAttribute('aria-controls'));
    if(targetElement) targetElement.removeAttribute('hidden');
    button.ariaSelected = true;
    window.setGridHeight(".cart_sample_content .grid__item .card-information__text");
    window.setGridHeight(".cart_sample_content .grid__item .card-bottom-information__button .button");
    window.setGridHeight(".cart_sample_content .grid__item .card-bottom-information__button");
    window.setGridHeight(".cart_sample_content .grid__item .cart-item__discounted-prices");
    window.setGridHeight(".cart_sample_content .grid__item .card-information__wrapper .price");
    window.setGridHeight(".cart_sample_content .grid__item .card-information ");
    window.setGridHeight(".cart_sample_content .grid__item .card-wrapper");
  }
}
window.customElements.define('cart-sample-selector',cartSampleSelector);

class RemoveGiftProduct extends HTMLElement {
  connectedCallback() {
    setTimeout(() => {
      const scriptTag = this.querySelector('script[type="application/json"]');
      this.productData = JSON.parse(scriptTag.textContent);
      let cartItems = this.closest('cart-items');
      let cartItemProducts = [
        this.productData.cartItem_tab_one_product,
        this.productData.cartItem_tab_two_product,
        this.productData.cartItem_tab_three_product
      ];
       cartItemProducts = cartItemProducts
          .filter(id => id !== "")
          .map(id => ({ id, qty: 0 }));

        cartItems.updateQuantity(null, null, null, cartItemProducts);
      return;

      if (scriptTag) {
        try {
          console.log("cartItemProducts",cartItemProducts)

          cartItemProducts.forEach((variantId) => {
            if (variantId) {
              // this.removeProductFromCart(variantId);
            }
          });
        } catch (error) {
          console.error("Failed to parse product data JSON:", error);
        }
      } else {
        console.error("Script tag with type 'application/json' not found.");
      }
    }, 1000);
  }
}

window.customElements.define('remove-gift-product', RemoveGiftProduct);

class CartSampleSelectorValidation extends HTMLElement {
  connectedCallback() {
    setTimeout(() => {
      const scriptTag = this.querySelector('script[type="application/json"]');
      if (!scriptTag) {
        console.warn('No JSON script tag found in <cart-sample-selector-validation>.');
        return;
      }

      let data;
      try {
        data = JSON.parse(scriptTag.textContent);
      } catch (error) {
        console.error('Invalid JSON in <cart-sample-selector-validation>', error);
        return;
      }

      const sampleIds = data._is_sample_products_id || [];
      const matchedIds = data.matched_cart_variant_ids || [];

      // Prepare update list with qty: 1 for _is_sample_products_id (to fix over-quantity)
      const sampleUpdateList = sampleIds.map(id => ({
        id,
        qty: 1
      }));

      // Prepare update list with qty: 0 for matched_cart_variant_ids (to remove from cart)
      const matchedUpdateList = matchedIds.map(id => ({
        id,
        qty: 0
      }));

      // Combine both update lists
      const updateList = [...sampleUpdateList, ...matchedUpdateList];

      const cartItems = this.closest('cart-items');
      if (!cartItems || typeof cartItems.updateQuantity !== 'function') {
        console.warn('<cart-items> element or its updateQuantity() method not found.');
        return;
      }

      cartItems.updateQuantity(null, null, null, updateList);
    }, 300);
  }
}

window.customElements.define('cart-sample-selector-validation', CartSampleSelectorValidation);


class CartSampleSelectorValidationLimit extends HTMLElement {
  connectedCallback() {
    setTimeout(() => {
      const scriptTag = this.querySelector('script[type="application/json"]');
      if (!scriptTag) return;

      let data = {};
      try {
        data = JSON.parse(scriptTag.textContent);
      } catch (err) {
        console.error("Failed to parse validation limit JSON:", err);
        return;
      }

      const variantIds = data.remaining_sample_variant_ids || [];
      if (!Array.isArray(variantIds) || variantIds.length === 0) return;

      const cartItems = this.closest('cart-items');
      if (!cartItems || typeof cartItems.updateQuantity !== 'function') return;

      const productsToRemove = variantIds.map(id => ({
        id,
        qty: 0
      }));

      cartItems.updateQuantity(null, null, null, productsToRemove);
    }, 500); // Adjust delay if needed
  }
}

window.customElements.define('cart-sample-selector-validation-limit', CartSampleSelectorValidationLimit);